/** @deprecated */
export class OpenFeedbackWindowHandler {
    public handle(): void {
        // TODO remove when webgl stop calling cmd
        console.log('OpenFeedbackWindow stub. Staged to remove');
    }
}
